import React, { useEffect, useState } from 'react';

import setQuery from '../../../../lib/setQuery.js';
import BoundSelect from 'components/boundForm/BoundSelect.js';
import { useSelector } from 'react-redux';
import { selectors } from 'selectors/selectors';
import useBoundForm from 'hooks/useBoundForm.js';
import { Col } from 'react-bootstrap';
import { action } from 'lib/actionHelpers.js';

const syncCondition = (n, activeLeadSyncPlatforms) => {
  if (n.syncCondition && n.syncCondition !== activeLeadSyncPlatforms) {
    return true;
  }
  if (n.syncCondition && n.syncCondition === activeLeadSyncPlatforms) {
    return false;
  }
  return false;
};

const ComposerModal = (props) => {
  const [active, setActive] = useState(false);
  const activeComposerType = useSelector(selectors['activeComposerType']);
  const selectedIntegrationAction = useSelector(selectors.integrationAction);
  const integrationActions = (activeComposerType || {}).actions || [];
  const activeLeadSyncPlatforms = useSelector(selectors.activeLeadSyncPlatforms);
  const showDraftSavedNotificaton = useSelector((state) => state.leadModal.showDraftSavedNotificaton);
  const [notificationState, setNotificationState] = useState(false);

  useEffect(() => {
    if (showDraftSavedNotificaton) {
      setNotificationState(true);
    }
  }, [showDraftSavedNotificaton]);

  const integrationActionOptions = (integrationActions || []).map((n) => ({ ...n, label: n.label, value: n.queryParam, integrationAction: n.queryParam, disabled: syncCondition(n, activeLeadSyncPlatforms) }));
  const form = useBoundForm({
    initialState: {
      integrationAction: selectedIntegrationAction,
    },
  });
  const handleCloseClick = (e) => {
    e.preventDefault();
    setActive(false);
    setQuery({ type: null, replyTo: null, template: null, burstActionId: null, actionPipelineLeadId: null, integrationAction: null });
    if ((activeComposerType || {}).type === 'email') {
      action('RESET_COMPOSER_EMAIL');
    }
  };

  const handleIntegrationActionChange = (param) => {
    form.set('integrationAction', param);
    setQuery({ ia: param });
  };

  useEffect(() => {
    setActive(true);
    const focusElement = document.querySelector(props.focusElement);
    if (focusElement) {
      setTimeout(() => {
        focusElement && focusElement.focus();
      }, 100);
    }
  }, []);

  useEffect(() => {
    if (selectedIntegrationAction && selectedIntegrationAction !== form.integrationAction) {
      form.set('integrationAction', selectedIntegrationAction);
    }
  }, [selectedIntegrationAction, form.integrationAction]);

  return (
    <div className={`composer ${props.className || ''} ${active ? 'active' : ''} scrollbar-light`}>
      <div className={'composer-header'}>
        <div className={'composer-heading'}>
          <div className={'composer-title'}>
            {props.title} {(activeComposerType || {}).type === 'email' && notificationState ? <span>Draft saved</span> : null}
          </div>
        </div>

        {(integrationActions || []).length ? (
          <Col className={'integrations-actions-select-container'} lg="6" md="6" sm="6">
            <BoundSelect
              disabled={true}
              formId={form.id}
              id={'integrationAction'}
              placeholder={'Actions'}
              options={integrationActionOptions}
              onChange={(param) => {
                handleIntegrationActionChange(param);
              }}
            />
          </Col>
        ) : null}
        <div className="composer-close-button" onClick={handleCloseClick}>
          <div>{'✖'}</div>
        </div>
      </div>
      <div className={'composer-body'}>{props.children}</div>
    </div>
  );
};

export default ComposerModal;
